/**
 * Catálogo curado de frecuencias de medicación para uso en prescripciones.
 * Agrupado por categoría clínica. La UI usa Autocomplete freeSolo, así que
 * el médico puede tipear texto libre fuera de esta lista (no se persiste al global).
 *
 * Orden interno por categoría: las opciones MÁS USADAS van primero.
 */

export const FRECUENCIAS_MEDICAMENTOS = [
  // ── Por intervalo horario (las más comunes) ──
  { categoria: 'Por intervalo horario', label: 'Cada 8 horas' },
  { categoria: 'Por intervalo horario', label: 'Cada 12 horas' },
  { categoria: 'Por intervalo horario', label: 'Cada 24 horas' },
  { categoria: 'Por intervalo horario', label: 'Cada 6 horas' },
  { categoria: 'Por intervalo horario', label: 'Cada 4 horas' },
  { categoria: 'Por intervalo horario', label: 'Cada 2 horas' },
  { categoria: 'Por intervalo horario', label: 'Cada 3 horas' },
  { categoria: 'Por intervalo horario', label: 'Cada 48 horas' },
  { categoria: 'Por intervalo horario', label: 'Cada 72 horas' },

  // ── Por número de veces al día ──
  { categoria: 'Veces al día', label: 'Una vez al día' },
  { categoria: 'Veces al día', label: 'Dos veces al día' },
  { categoria: 'Veces al día', label: 'Tres veces al día' },
  { categoria: 'Veces al día', label: 'Cuatro veces al día' },

  // ── Por horario del día ──
  { categoria: 'Horario del día', label: 'Por la mañana' },
  { categoria: 'Horario del día', label: 'Al mediodía' },
  { categoria: 'Horario del día', label: 'Por la noche' },
  { categoria: 'Horario del día', label: 'Antes de dormir' },
  { categoria: 'Horario del día', label: 'Mañana y noche' },
  { categoria: 'Horario del día', label: 'Mañana, tarde y noche' },

  // ── Con relación a comidas ──
  { categoria: 'Con relación a comidas', label: 'En ayunas' },
  { categoria: 'Con relación a comidas', label: 'Antes de las comidas' },
  { categoria: 'Con relación a comidas', label: 'Después de las comidas' },
  { categoria: 'Con relación a comidas', label: 'Con las comidas' },
  { categoria: 'Con relación a comidas', label: 'Antes del desayuno' },
  { categoria: 'Con relación a comidas', label: 'Después del desayuno' },
  { categoria: 'Con relación a comidas', label: '30 minutos antes de comer' },
  { categoria: 'Con relación a comidas', label: '2 horas después de comer' },

  // ── Por razón necesaria (PRN) ──
  { categoria: 'Por razón necesaria', label: 'Por razón necesaria' },
  { categoria: 'Por razón necesaria', label: 'En caso de dolor' },
  { categoria: 'Por razón necesaria', label: 'En caso de fiebre' },
  { categoria: 'Por razón necesaria', label: 'En caso de náusea' },
  { categoria: 'Por razón necesaria', label: 'En caso de ansiedad' },
  { categoria: 'Por razón necesaria', label: 'Solo si hay molestia' },

  // ── Frecuencias semanales/mensuales ──
  { categoria: 'Semanal o mensual', label: 'Una vez a la semana' },
  { categoria: 'Semanal o mensual', label: 'Dos veces a la semana' },
  { categoria: 'Semanal o mensual', label: 'Tres veces a la semana' },
  { categoria: 'Semanal o mensual', label: 'Lunes, miércoles y viernes' },
  { categoria: 'Semanal o mensual', label: 'Cada 15 días' },
  { categoria: 'Semanal o mensual', label: 'Una vez al mes' },

  // ── Aplicación tópica/inyectable ──
  { categoria: 'Aplicación', label: 'Aplicar 2 veces al día' },
  { categoria: 'Aplicación', label: 'Aplicar 3 veces al día' },
  { categoria: 'Aplicación', label: 'Aplicar al acostarse' },
  { categoria: 'Aplicación', label: 'Una sola aplicación' },
  { categoria: 'Aplicación', label: 'Dosis única' },
];
